/*
 *   This positioner drops the tooltip to the center of the bar and offsets it form the bar,
 *   if there is enough room to do so.
 */

import Chart from "chart.js";

Chart.Tooltip.positioners.half = function (elements) {
	let xOffset = 0;
	let yOffset = 0;

	// If it's not a super short bar, give it a left or right offset based on the position of the tooltip
	if (elements[0]._chart.height - elements[0]._view.y > 20) {
		if (
			elements[0]._chart.width / 2 >
			elements[0]._view.x + elements[0]._view.width / 2
		) {
			xOffset = 10;
		} else {
			xOffset = -10;
		}

		// If it's a tall bar, vertically center tooltip
		if (elements[0]._chart.height - elements[0]._view.y > 50) {
			yOffset = (elements[0]._chart.height - elements[0]._view.y) / 2;
		}
	}

	return {
		x: elements[0]._view.x + xOffset,
		y: elements[0]._view.y + yOffset,
	};
};

export default Chart;
